module.exports = __webpack_public_path__ + "static/media/image-off-gray.fa1a2f2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/image-off-gray.svg
// module id = 770
// module chunks = 0